import { FeedbackRequest, FeedbackResponse } from '@/types/feedback';

const API_BASE_URL = import.meta.env.VITE_API_URL;
if (!API_BASE_URL) {
  throw new Error('VITE_API_URL environment variable is not defined');
}

export const submitFeedback = async (requestBody: FeedbackRequest, jwtToken?: string): Promise<FeedbackResponse> => {
  const isDevelopment = import.meta.env.MODE === 'development';
  
  if (isDevelopment) {
    console.log('POST /feedback');
    console.log('Request Body:', JSON.stringify(requestBody, null, 2));
  }

  try {
    // Make actual HTTP POST request
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };
    if (jwtToken) {
      headers['Authorization'] = `Bearer ${jwtToken}`;
    }
    const response = await fetch(`${API_BASE_URL}/feedback`, {
      method: 'POST',
      headers,
      body: JSON.stringify(requestBody)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData: FeedbackResponse = await response.json();
    
    if (isDevelopment) {
      console.log('Response:', JSON.stringify(responseData, null, 2));
    }
    
    return responseData;
  } catch (error) {
    if (isDevelopment) {
      console.error('Failed to submit feedback:', error);
    }
    throw (error instanceof Error)
      ? error
      : new Error('Failed to submit feedback');
  }
};
